module.exports = "/_next/static/images/9cb9899dfc799d6c00818ca69d4d916b-credit-card-autonomy@2x.png.webp";